const storeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage = (shouldShowEnterPasswordToLinkFacebookToast) => {
  localStorage.setItem('anova_should_show_enter_password_to_link_facebook_toast', JSON.stringify(shouldShowEnterPasswordToLinkFacebookToast))
}

export default storeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage
